import { render } from "./Loader.vue?vue&type=template&id=5c12c6fa&scoped=true"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=5c12c6fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c12c6fa"]])

export default __exports__